@if (mapItem(); as mapItem) {
    <ui-detail-view-container>
        <ui-detail-section>
            <ui-detail-image
                [imagePath]="mapItem.imagePath"
                [altText]="mapItem.title"
            />
            <ui-detail-title [title]="mapItem.title"/>
            <ui-detail-address [text]="mapItem.address"/>
            <ui-detail-tags
                [tags]="[mapItem.typeLabel]"
            />
        </ui-detail-section>
        @if (mapItem.shortDescription) {
            <ui-detail-description
                [htmlDescription]="mapItem.shortDescription"
            />
        }
        @if (mapItem.locationDescription) {
            <ui-detail-description
                [title]="'Standortbeschreibung'"
                [htmlDescription]="mapItem.locationDescription"
            />
        }
        @if (mapItem.weblink) {
            <ui-detail-weblink
                [title]="'Website'"
                [link]="mapItem.weblink"
            />
        }
        @if (mapItem.accessibilityFeatures.length) {
            <ui-detail-tags
                [title]="'Barrierefreiheit'"
                [tags]="mapItem.accessibilityFeatures"
            />
        }
        @if (mapItem.openingTimes) {
            <ui-detail-description
                [title]="'Öffnungszeiten'"
                [htmlDescription]="mapItem.openingTimes"
            />
        }
        @if (mapItem.contact) {
            <ui-detail-description
                [title]="'Ansprechperson'"
                [htmlDescription]="mapItem.contact"
            />
        }
        @if (mapItem.linkedItems.length) {
            <ui-detail-table
                [titleLeft]="mapItem.linkedItemsLabel"
            >
                @for (linkedItem of mapItem.linkedItems; track linkedItem.id) {
                    <ui-detail-table-row>
                        <ui-detail-link
                            left
                            [label]="linkedItem.name"
                            (mapItemLinkClicked)="triggerMapItemById(linkedItem)"
                        />
                        <ui-detail-tags
                            right
                            [rightAligned]="true"
                            [tags]="linkedItem.sports"
                        />
                    </ui-detail-table-row>
                }
            </ui-detail-table>
        }
    </ui-detail-view-container>
}
